// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	angular.module("swurveys.common")
		.filter("unsafe", Handler)

	function Handler($sce) {
		return $sce.trustAsHtml;
	}

}());
